<template lang="pug">
  .profile-page.page
    .container
      .profile-page__container
        .profile-page__side.md
          side-nav(
          v-bind:sideNavData="sideNavData"
          )
        .profile-page__main.md
          //.profile-page__header
            .profile-page__title
              h1.title Описание смены
          .profile-page__tabs
            tab-nav(
            v-bind:tabNavData="tabNavData"
            )
          .profile-page__content
            section.profile-page-form__section.profile-section
              .profile-section__title
                h2.profile-section-title Общая информация
              .profile-section__body
                .form
                  .form__elem
                    .form-elem.form-elem_horizontal
                      .form-elem__title Название
                      .form-elem__body
                        input.input.input_full(
                        maxlength="50"
                        value="Английская"
                        )
                  .form__elem
                    .form-elem.form-elem_horizontal
                      .form-elem__title Теги:
                      .form-elem__body
                        multiselect.multiselect--lite(
                        v-model="value",
                        tag-placeholder="Добавьте или выберите тег",
                        placeholder="Добавьте или выберите тег",
                        label="name",
                        track-by="code",
                        :options="options",
                        :multiple="true",
                        :taggable="true",
                        @tag="addTag",
                        selectLabel="Выбрать"
                        deselectLabel="Удалить"
                        selectedLabel="Выбран"
                        )
                  .form__elem.form__elem
                    .form-elem.form-elem_horizontal
                      .form-elem__title Даты проведения смены
                      .form-elem__body.form-elem__body_double
                        date-picker(
                        placeholder="дд.мм.гггг"
                        v-model="localDateOfBirth"
                        format="DD.MM.YYYY"
                        lang="ru"
                        input-class="input input_full"
                          @change="onChangeDate($event)"
                            :clearable="false"
                            :editable="true"
                            :not-after="new Date()"
                        )
                        .separator -
                        date-picker(
                        placeholder="дд.мм.гггг"
                        v-model="localDateOfBirth"
                        format="DD.MM.YYYY"
                        lang="ru"
                        input-class="input input_full"
                          @change="onChangeDate($event)"
                            :clearable="false"
                            :editable="true"
                            :not-after="new Date()"
                        )
                  .form__elem.form__elem_short
                    .form-elem.form-elem_horizontal
                      .form-elem__title Диапазон возраста участников смены
                      .form-elem__body.form-elem__body_double
                        input.input.input_sm(
                        maxlength="50"
                        placeholder="10"
                        )
                        .separator -
                        input.input.input_sm(
                        maxlength="50"
                        placeholder="17"
                        )

            section.profile-page-form__section.profile-section
              .profile-section__title
                h2.profile-section-title Текстовое описание

              .profile-section__body
                .form
                  .form__elem.form__elem_full
                    .form-elem.form-elem_horizontal
                      textarea.textarea.textarea_full(
                      rows="10"
                      )
                  .form__elem
                    .form-elem.form-elem_horizontal
                      .form-elem__title Ссылка на видео
                      .form-elem__body
                        input.input.input_full(
                        maxlength="50"
                        value=""
                        )
            section.profile-page-form__section.profile-section
              .profile-section__title
                h2.profile-section-title Фотографии

              .profile-section__body
                .form
                  .form__elem.form__elem_full
                    .photo-upload
                      .photo-upload__text Размер фото не больше 3мб
                      .photo-upload__container
                        .photo-upload__img
                          img(src="@/assets/images/photo-upload-test/1.jpg")
                        .photo-upload__img
                          img(src="@/assets/images/photo-upload-test/2.jpg")
                        .photo-upload__img
                          img(src="@/assets/images/photo-upload-test/3.jpg")
                        .photo-upload__img
                          img(src="@/assets/images/photo-upload-test/4.jpg")
                        .photo-upload__img
                          img(src="@/assets/images/photo-upload-test/5.jpg")
                        //.photo-upload__img
                          img(src="@/assets/images/photo-upload-test/6.jpg")
                        .photo-upload__button.button.button_paint-main--light
                          .button__icon
                            img(src="@/assets/images/icons/clip.svg")
                          .button__text Добавить файл

            section.form__elem.form__elem--align-right.form__elem_full
              button.button.button_paint-main.button_long
                .button__text Сохранить
</template>
<script>
import {mapState, mapActions} from "vuex";

import Multiselect from "vue-multiselect";
import MainFooter from "@/components/footer/Footer";
import SideNav from "@/components/sideNav/SideNav";
import TabNav from "../../../../components/tabNav/TabNav.vue";
import DatePicker from "vue2-datepicker";
import SimpleSelectForm from "../../../../components/simpleSelectForm/SimpleSelectForm.vue";

export default {
  name: "DirectorShiftsDescription",
  components: {
    SimpleSelectForm,
    DatePicker,
    TabNav,
    SideNav,
    MainFooter,
    Multiselect
  },
  props: ["sideNavData"],
  data() {
    return {
      tabNavData: {
        tabs: [
          {
            path: "/pages/director/shift/create",
            text: "Общая информация"
          },
          {
            path: "/pages/director/shift/quota",
            text: "Квоты"
          },
          {
            path: "/pages/director/shift/about",
            text: "Описание"
          },
          {
            path: "/pages/director/shift/program",
            text: "Программа"
          },
          {
            path: "/pages/director/shift/schedule",
            text: "Распорядок дня"
          },
          {
            path: "/pages/director/shift/teachers",
            text: "Педагоги"
          },
          {
            path: "/pages/director/shift/contacts",
            text: "Контакты"
          }
        ],
        profileListData: [
          {
            text: "Тематическая ",
            value: true
          },
          {
            text: "Специализированная",
            value: false
          }
        ]
      },
      value: [
        {name: "Спорт", code: "sport"}
      ],
      options: [
        {name: "Спорт", code: "sport"},
        {name: "Компьютеры", code: "computers"}
      ]
    };
  },
  computed: {
    localGender: {

    }
  },
  methods: {
    onSelectItem(li) {
      this.$emit("onSelectItem", li);
      this.$emit("close");
    },
    onClickList(e) {
      e.preventDefault();
      e.stopPropagation();
    },
    onBodyClick() {
      this.$emit("close");
    }
  },
  beforeDestroy() {
    document.body.removeEventListener("click", this.onBodyClick);
  },
  created() {
    document.body.addEventListener("click", this.onBodyClick);
  }
//  computed: {
//    localDateOfBirth: {
//      get() {
//        if (!this.dateOfBirth) {
//          return "";
//        }
//        return this.dateOfBirth;
//      },
//      set() {}
//    },
//  },
//  methods: {
//    onChangeDate(date) {
//      const d = new Date(date);
//      const _date = `${d.getFullYear()}-${("0" + (d.getMonth() + 1)).slice(
//        -2
//      )}-${("0" + d.getDate()).slice(-2)}`;
//      this.$emit("onChangeValue", [_date, "date_of_birth"]);
//    },
//  }
};
</script>
